import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";


import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import "./components/Navbar/NavStyle.css";
import DashDock from "./components/Dashboard/Docks";
import Dashboard from "./components/Dashboard/Dashboard";
import Navbars from "./components/Navbar/Navbar";
import Default from "./components/Dashboard/Default";
import "./components/Dashboard/Dashboard.css";
import HelpQuestions from "./components/common/help";
import Futuristic from "./components/Dashboard/Futuristic";
import React, { createContext, useEffect, useState, useRef } from "react";
import { useGlobal } from "./GlobalContext";
import axios from "axios";
import { getCookie } from "./components/getcookie";
import PreLanding from "./pre-landing";
import UnAuthorized from "./components/common/unauthorized";
import DeviceList from "./components/devices/device-list.js";
import DeviceGroupCreate from "./components/device-group/device-group-create.js";
import SlideWidgets from "./components/devices/slid-widget.js";
import GroupList from "./components/device-group/group-list.js";
import ParentComponent from "./components/devices/ifram-parent.js";
function App() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const location = useLocation();
  // List of paths where header should be hidden
  const hideHeaderPaths = ["/"];

  const shouldHideHeader = hideHeaderPaths.includes(location.pathname);
  const { rolePermissionList, setRolePermissionList, userType, setUserType } = useGlobal();

  useEffect(() => {
    getRolePermission();
  }, []);

  const getRolePermission = async () => {
    try {
      const response = await axios
        .get(adminApiUrl + "get_role_permission/9", {
          params: {},
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*", // Required for CORS support to work
            Authorization: getCookie("mawalog"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              setUserType(response.data.user_type);
              setRolePermissionList(response.data.role_permission ?? []);
              localStorage.setItem("rolePermissionList", JSON.stringify(response.data.role_permission ?? []));
              localStorage.setItem("userType", response.data.user_type ?? "");
              console.log("lsr", localStorage.getItem("rolePermissionList"));
              console.log("lsu", localStorage.getItem("userType"));
            } else {
              setRolePermissionList([]);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 401) {
              document.cookie = "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
              document.cookie = "mawalog=; path=/; domain=.mawalog.com";
              window.location.href = accountsUrl;
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };
  return (
    <>
      {!shouldHideHeader && <Navbars />}
      <Routes>
        <Route path="/" element={<PreLanding />} />
        {/*  <Route path="/" element={<Navigate to="/dashboard/default" />} /> */}

        <Route path="/dashdock" element={<DashDock />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="default" element={<Default />} />
          <Route path="futuristic" element={<Futuristic />} />
        </Route>

        <Route path="/devices" element={/* userType === "SA" || userType === "A" ? */ <DeviceList /> /* : <UnAuthorized /> */} />
        <Route path="/group" element={/* userType === "SA" || userType === "A" ? */ <GroupList /> /* : <UnAuthorized /> */} />
         <Route path="/group/create" element={/* userType === "SA" || userType === "A" ? */ <DeviceGroupCreate /> /* : <UnAuthorized /> */} />
       

 <Route path="/iframetest" element={<ParentComponent />} />
 <Route path="/signage" element={<SlideWidgets />} />
     
        <Route path="/help" element={<HelpQuestions />}></Route>
      </Routes>
    </>
  );
}

export default App;
